/* GRIMZO – JS vanilla : tiroir panier, ajout AJAX (solo + packs), choix des visages, galerie. */

(function () {

  'use strict';

  var SECTION = 'grimzo-cart';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var MSG_NETWORK = 'Connexion perdue. Vérifie ton réseau et réessaie.';
  var MSG_STOCK = 'Ce masque n’est plus disponible en quantité suffisante. Réessaie ou choisis un autre visage.';

  /* Temps pendant lequel "✓ Ajouté !" reste visible avant ouverture du panier */
  var ADD_SUCCESS_DELAY = 550;

  var lastFocus = null;


  function drawer() {
    return document.getElementById('gz-cart');
  }


  function wait(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }


  function updateCount(n) {
    document.querySelectorAll('[data-gz-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = !n;
    });
  }


  /* ---------- Tiroir du panier ---------- */

  function openCart() {
    var d = drawer();

    if (!d) return;

    lastFocus = document.activeElement;

    d.hidden = false;
    document.body.classList.add('gz-lock');

    var close = d.querySelector('button[data-gz-cart-close]');

    (close || d.querySelector('.gz-drawer__panel')).focus();
  }


  function closeCart() {
    var d = drawer();

    if (!d || d.hidden) return;

    d.hidden = true;
    document.body.classList.remove('gz-lock');

    if (lastFocus && lastFocus.focus) {
      lastFocus.focus();
    }
  }


  function renderCart(html) {
    var d = drawer();

    if (!d || !html) return false;

    var fresh = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('gz-cart');

    if (!fresh) return false;

    d.innerHTML = fresh.innerHTML;

    updateCount(
      parseInt(fresh.getAttribute('data-count'), 10) || 0
    );

    var close = d.querySelector('button[data-gz-cart-close]');

    if (close && !d.hidden) {
      close.focus();
    }

    return true;
  }


  function showErrors(els, msg) {
    Array.prototype.forEach.call(els, function (el) {
      el.textContent = msg;
      el.hidden = false;
    });
  }


  function hideErrors(els) {
    Array.prototype.forEach.call(els, function (el) {
      el.hidden = true;
    });
  }


  /*
   * form.id est masqué par le champ name="id".
   * On lit donc directement l'attribut HTML.
   */
  function formId(form) {
    return form.getAttribute('id');
  }


  function errorsFor(id) {
    return Array.prototype.slice.call(
      document.querySelectorAll('[data-gz-err="' + id + '"]')
    );
  }


  function jsonPost(path, payload) {
    return fetch(root + path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().then(function (body) {
        return {
          ok: r.ok,
          body: body
        };
      });
    });
  }


  /* ---------- Feedback bouton Ajouter ---------- */

  function getButtonLabels(btns) {
    return btns.map(function (button) {
      var label = button.querySelector('[data-gz-add-label]');

      return {
        button: button,
        label: label,
        originalText: label ? label.textContent : ''
      };
    });
  }


  function setAddingState(labels) {
    labels.forEach(function (item) {
      item.button.disabled = true;
      item.button.setAttribute('aria-busy', 'true');

      if (item.label) {
        item.label.textContent = 'Ajout…';
      }
    });
  }


  function setSuccessState(labels) {
    labels.forEach(function (item) {
      item.button.removeAttribute('aria-busy');

      if (item.label) {
        item.label.textContent = '✓ Ajouté !';
      }
    });
  }


  function restoreButtons(labels) {
    labels.forEach(function (item) {
      var button = item.button;

      button.removeAttribute('aria-busy');

      if (item.label) {
        item.label.textContent = item.originalText;
      }

      if (
        button.hasAttribute('data-needs-pack') &&
        button.form &&
        !button.form.querySelector('input[name="pack"]:checked')
      ) {
        button.disabled = true;
      } else {
        button.disabled = false;
      }
    });
  }


  /*
   * Ajoute une liste d'articles en UN seul appel /cart/add.js.
   * ui = { btns, errors }
   */
  function addItems(items, ui) {

    var labels = getButtonLabels(ui.btns);

    hideErrors(ui.errors);
    setAddingState(labels);

    var success = false;

    return jsonPost(
      'cart/add.js',
      {
        items: items,
        sections: SECTION,
        sections_url: window.location.pathname
      }
    )

      .then(function (res) {

        if (!res.ok) {
          showErrors(ui.errors, MSG_STOCK);
          return false;
        }

        var sectionHtml =
          res.body.sections &&
          res.body.sections[SECTION];

        if (renderCart(sectionHtml)) {
          success = true;
          return true;
        }

        /*
         * Sécurité :
         * si Shopify ne renvoie pas la section du panier,
         * on récupère au minimum le compteur réel.
         */
        return fetch(root + 'cart.js', {
          headers: {
            Accept: 'application/json'
          }
        })

          .then(function (r) {
            return r.json();
          })

          .then(function (cart) {
            updateCount(cart.item_count);
            success = true;
            return true;
          });
      })

      .then(function (wasAdded) {

        if (!wasAdded) {
          return;
        }

        /*
         * Feedback immédiat :
         * Ajout… → ✓ Ajouté !
         */
        setSuccessState(labels);

        return wait(ADD_SUCCESS_DELAY)

          .then(function () {
            openCart();
          });
      })

      .catch(function () {
        success = false;
        showErrors(ui.errors, MSG_NETWORK);
      })

      .then(function () {
        restoreButtons(labels);

        /*
         * Le booléen est conservé volontairement :
         * il permet de distinguer un ajout réussi
         * d'une erreur réseau/stock si on enrichit
         * ce comportement plus tard.
         */
        return success;
      });
  }


  /* ---------- Modification quantité panier ---------- */

  function changeLine(line, qty) {

    return jsonPost(
      'cart/change.js',
      {
        line: line,
        quantity: qty,
        sections: SECTION,
        sections_url: window.location.pathname
      }
    )

      .then(function (res) {

        if (res.ok && res.body.sections) {
          renderCart(res.body.sections[SECTION]);
          return;
        }

        showErrors(
          document.querySelectorAll('[data-gz-cart-error]'),
          MSG_STOCK
        );
      })

      .catch(function () {
        showErrors(
          document.querySelectorAll('[data-gz-cart-error]'),
          MSG_NETWORK
        );
      });
  }


  /* ---------- Prix affichés (format « CHF 29.90 ») ---------- */

  function formatMoney(cents, currency) {

    if (currency === 'CHF') {
      return 'CHF ' + (cents / 100).toFixed(2);
    }

    try {

      return new Intl.NumberFormat(
        document.documentElement.lang || undefined,
        {
          style: 'currency',
          currency: currency
        }
      ).format(cents / 100);

    } catch (e) {

      return (cents / 100).toFixed(2) + ' ' + currency;

    }
  }


  function setThumb(img, data) {

    if (!img) return;

    var url = data && data.thumb;

    if (!url) {
      img.hidden = true;
      return;
    }

    img.hidden = false;
    img.src = url;

    img.srcset =
      url +
      ' 64w, ' +
      data.thumb2x +
      ' 128w';
  }


  /* ---------- Packs : choix du pack, puis des visages ---------- */

  function slotInput(form, n) {
    return form.querySelector(
      'input[name="slot-' + n + '"]'
    );
  }


  function updatePacks(form) {

    var picker = form.closest('[data-gz-picker]');

    var currency =
      (picker && picker.dataset.currency) ||
      'CHF';

    var chosen =
      form.querySelector('input[name="pack"]:checked');

    var size =
      chosen
        ? parseInt(chosen.dataset.packSize, 10)
        : 0;


    var config =
      form.querySelector('[data-gz-config]');

    var hint =
      form.querySelector('[data-gz-config-hint]');

    if (config) {
      config.hidden = !chosen;
    }

    if (hint) {
      hint.hidden = !!chosen;
    }


    var addBtn =
      form.querySelector('[data-gz-pack-add]');

    if (addBtn) {
      addBtn.disabled = !chosen;
    }


    var picked = [];


    form.querySelectorAll('[data-slot]').forEach(function (slot) {

      var idx =
        parseInt(slot.dataset.slot, 10);

      slot.hidden = idx > size;

      var input =
        slot.querySelector('input[type="hidden"]');

      picked[idx - 1] = input;

      var nameEl =
        slot.querySelector('[data-slot-name]');

      if (nameEl) {
        nameEl.textContent = input.dataset.name;
      }

      setThumb(
        slot.querySelector('.gz-slot__img'),
        input.dataset
      );
    });


    /*
     * Estimation affichée, calquée sur la règle
     * d'arrondi de Shopify.
     *
     * Le montant réellement appliqué reste celui
     * affiché par Shopify dans le panier.
     */
    form.querySelectorAll('.gz-packwrap').forEach(function (card) {

      var radio =
        card.querySelector('input[name="pack"]');

      var n =
        parseInt(radio.dataset.packSize, 10);

      var pct =
        parseFloat(radio.dataset.pct) || 0;

      var lines = {};
      var old = 0;


      for (var i = 0; i < n; i++) {

        var r = picked[i];

        if (!r) continue;

        var price =
          parseInt(r.dataset.price, 10);

        old += price;

        lines[r.value] =
          lines[r.value] ||
          {
            price: price,
            qty: 0
          };

        lines[r.value].qty += 1;
      }


      var save = 0;


      Object.keys(lines).forEach(function (k) {

        /*
         * Shopify :
         * remise par article arrondie au centime,
         * puis multipliée par la quantité.
         */
        save +=
          Math.floor(
            (lines[k].price * pct + 49) / 100
          ) *
          lines[k].qty;
      });


      var total = old - save;


      card.querySelector(
        '[data-pack-old-amount]'
      ).textContent =
        formatMoney(old, currency);


      card.querySelector(
        '[data-pack-price]'
      ).textContent =
        formatMoney(total, currency);


      card.querySelector(
        '[data-pack-save-amount]'
      ).textContent =
        formatMoney(save, currency);


      card.querySelector(
        '[data-pack-each-amount]'
      ).textContent =
        formatMoney(
          Math.round(total / n),
          currency
        );


      card.querySelectorAll(
        '.gz-face__img'
      ).forEach(function (img, i) {

        setThumb(
          img,
          picked[i] &&
          picked[i].dataset
        );

      });
    });
  }


  function packItems(form) {

    var chosen =
      form.querySelector('input[name="pack"]:checked');

    var size =
      chosen
        ? parseInt(chosen.dataset.packSize, 10)
        : 0;

    var counts = {};
    var order = [];


    for (var s = 1; s <= size; s++) {

      var r =
        slotInput(form, s);

      if (!r || !r.value) {
        continue;
      }

      if (!counts[r.value]) {
        counts[r.value] = 0;
        order.push(r.value);
      }

      counts[r.value] += 1;
    }


    return order.map(function (id) {

      return {
        id: parseInt(id, 10),
        quantity: counts[id]
      };

    });
  }


  function withProtect(items, form) {

    var box =
      form.querySelector(
        'input[name="protect"]:checked'
      );

    if (box) {

      items.push({
        id: parseInt(box.value, 10),
        quantity: 1
      });

    }

    return items;
  }


  function setSlot(form, n, data) {

    var input =
      slotInput(form, n);

    if (!input) return;

    input.value = data.id;
    input.dataset.price = data.price;
    input.dataset.name = data.name;
    input.dataset.thumb = data.thumb || '';
    input.dataset.thumb2x = data.thumb2x || '';
  }


  function mixSlots(form) {

    var chosen =
      form.querySelector('input[name="pack"]:checked');

    var size =
      chosen
        ? parseInt(chosen.dataset.packSize, 10)
        : 0;

    var opts =
      Array.prototype.slice.call(
        form.querySelectorAll(
          '.gz-sheet__opt:not([disabled])'
        )
      );

    if (!opts.length) return;


    for (var s = 1; s <= size; s++) {

      setSlot(
        form,
        s,
        opts[
          Math.floor(
            Math.random() * opts.length
          )
        ].dataset
      );

    }


    updatePacks(form);
  }


  function openSheet(form, n, trigger) {

    var sheet =
      form.querySelector('[data-gz-sheet]');

    if (!sheet) return;

    sheet.dataset.forSlot = n;
    sheet.gzTrigger = trigger;


    var title =
      sheet.querySelector(
        '[data-gz-sheet-title]'
      );

    if (title) {
      title.textContent =
        'Visage du masque ' + n;
    }


    var current =
      slotInput(form, n).value;


    sheet.querySelectorAll(
      '.gz-sheet__opt'
    ).forEach(function (b) {

      b.setAttribute(
        'aria-pressed',
        b.dataset.id === current
          ? 'true'
          : 'false'
      );

    });


    if (
      typeof sheet.showModal === 'function'
    ) {

      sheet.showModal();

    } else {

      sheet.setAttribute('open', '');

    }
  }


  function closeSheet(sheet) {

    if (
      typeof sheet.close === 'function'
    ) {

      sheet.close();

    } else {

      sheet.removeAttribute('open');

      if (
        sheet.gzTrigger &&
        sheet.gzTrigger.focus
      ) {
        sheet.gzTrigger.focus();
      }

    }
  }


  /* ---------- Galerie produit ---------- */

  function loadDeferred(scope) {

    scope.querySelectorAll(
      'img[data-src]'
    ).forEach(function (img) {

      if (img.dataset.srcset) {
        img.srcset = img.dataset.srcset;
      }

      img.src = img.dataset.src;

      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');

    });
  }


  function galleryScrollTo(
    gallery,
    mediaId,
    instant
  ) {

    var track =
      gallery.querySelector(
        '[data-gz-track]'
      );

    var slide =
      track &&
      track.querySelector(
        '[data-media-id="' +
        mediaId +
        '"]'
      );

    if (!slide) return;


    loadDeferred(slide);


    var calm =
      instant ||
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;


    track.scrollTo({
      left:
        slide.offsetLeft -
        track.offsetLeft,
      behavior:
        calm
          ? 'instant'
          : 'smooth'
    });


    setTimeout(function () {

      galleryMarkActive(gallery);

    }, calm ? 30 : 500);
  }


  function galleryMarkActive(gallery) {

    var track =
      gallery.querySelector(
        '[data-gz-track]'
      );

    if (!track) return;


    var slides =
      track.querySelectorAll(
        '[data-media-id]'
      );

    var index =
      Math.round(
        track.scrollLeft /
        (track.clientWidth || 1)
      );

    var slide =
      slides[
        Math.min(
          index,
          slides.length - 1
        )
      ];


    gallery.querySelectorAll(
      '.gz-gallery__thumb'
    ).forEach(function (t) {

      t.setAttribute(
        'aria-current',
        slide &&
        t.dataset.mediaId ===
        slide.dataset.mediaId
          ? 'true'
          : 'false'
      );

    });
  }


  /* ---------- Événements ---------- */

  document.addEventListener(
    'click',
    function (e) {

      var t = e.target;

      if (!(t instanceof Element)) {
        return;
      }


      if (
        t.closest('[data-gz-cart-open]') &&
        drawer()
      ) {

        e.preventDefault();
        openCart();
        return;

      }


      if (
        t.closest('[data-gz-cart-close]')
      ) {

        closeCart();
        return;

      }


      var mix =
        t.closest('[data-gz-mix]');

      if (mix) {

        mixSlots(
          mix.closest(
            '[data-gz-pack-form]'
          )
        );

        return;
      }


      var slotBtn =
        t.closest(
          '[data-gz-slot-btn]'
        );

      if (slotBtn) {

        var slotEl =
          slotBtn.closest('[data-slot]');

        openSheet(
          slotBtn.closest(
            '[data-gz-pack-form]'
          ),
          parseInt(
            slotEl.dataset.slot,
            10
          ),
          slotBtn
        );

        return;
      }


      var opt =
        t.closest('.gz-sheet__opt');

      if (opt) {

        var sheet =
          opt.closest(
            '[data-gz-sheet]'
          );

        var form =
          sheet.closest(
            '[data-gz-pack-form]'
          );

        setSlot(
          form,
          parseInt(
            sheet.dataset.forSlot,
            10
          ),
          opt.dataset
        );

        updatePacks(form);
        closeSheet(sheet);

        return;
      }


      if (
        t.closest(
          '[data-gz-sheet-close]'
        )
      ) {

        closeSheet(
          t.closest(
            '[data-gz-sheet]'
          )
        );

        return;
      }


      if (
        t instanceof HTMLDialogElement &&
        t.hasAttribute(
          'data-gz-sheet'
        )
      ) {

        closeSheet(t);
        return;
      }


      var thumb =
        t.closest(
          '.gz-gallery__thumb'
        );

      if (thumb) {

        galleryScrollTo(
          thumb.closest(
            '[data-gz-gallery]'
          ),
          thumb.dataset.mediaId
        );

        return;
      }


      var q =
        t.closest('[data-gz-qty]');

      if (q) {

        q.disabled = true;

        changeLine(
          parseInt(
            q.dataset.line,
            10
          ),
          parseInt(
            q.dataset.qty,
            10
          )
        );

      }

    }
  );


  document.addEventListener(
    'submit',
    function (e) {

      var form = e.target;

      if (
        !(form instanceof HTMLFormElement)
      ) {
        return;
      }


      /* ---------- Ajout SOLO ---------- */

      if (
        form.hasAttribute(
          'data-gz-form'
        )
      ) {

        e.preventDefault();


        var checked =
          form.querySelector(
            'input[name="id"]:checked'
          );


        var btns =
          Array.prototype.slice.call(
            document.querySelectorAll(
              '[data-gz-add][form="' +
              formId(form) +
              '"], [id="' +
              formId(form) +
              '"] [data-gz-add]'
            )
          );


        var errs =
          errorsFor(
            formId(form)
          );


        if (!checked) {

          showErrors(
            errs,
            'Choisis d’abord un visage.'
          );

          return;
        }


        addItems(
          withProtect(
            [
              {
                id:
                  parseInt(
                    checked.value,
                    10
                  ),
                quantity: 1
              }
            ],
            form
          ),
          {
            btns: btns,
            errors: errs
          }
        );

      }


      /* ---------- Ajout PACK ---------- */

      else if (
        form.hasAttribute(
          'data-gz-pack-form'
        )
      ) {

        e.preventDefault();


        var perrs =
          Array.prototype.slice.call(
            form.querySelectorAll(
              '[data-gz-error]'
            )
          );


        var items =
          packItems(form);


        if (!items.length) {

          showErrors(
            perrs,
            'Choisis d’abord un pack.'
          );

          return;
        }


        addItems(
          withProtect(
            items,
            form
          ),
          {
            btns: [
              form.querySelector(
                '[data-gz-pack-add]'
              )
            ],
            errors: perrs
          }
        );

      }

    }
  );


  document.addEventListener(
    'change',
    function (e) {

      var input = e.target;

      if (
        !(input instanceof HTMLInputElement)
      ) {
        return;
      }


      if (
        input.hasAttribute(
          'data-gz-radio'
        )
      ) {

        document.querySelectorAll(
          '[data-gz-name]'
        ).forEach(function (el) {

          el.textContent =
            input.dataset.name;

        });


        document.querySelectorAll(
          '[data-gz-price]'
        ).forEach(function (el) {

          el.textContent =
            input.dataset.price;

        });


        setThumb(
          document.querySelector(
            '.gz-sticky__img'
          ),
          input.dataset
        );


        hideErrors(
          errorsFor(
            formId(input.form)
          )
        );


        var gallery =
          document.querySelector(
            '[data-gz-gallery]'
          );


        if (
          gallery &&
          input.dataset.media
        ) {

          galleryScrollTo(
            gallery,
            input.dataset.media
          );

        }

        return;
      }


      var packForm =
        input.closest(
          '[data-gz-pack-form]'
        );


      if (
        packForm &&
        input.name === 'pack'
      ) {

        updatePacks(packForm);

        hideErrors(
          Array.prototype.slice.call(
            packForm.querySelectorAll(
              '[data-gz-error]'
            )
          )
        );

      }

    }
  );


  document.addEventListener(
    'keydown',
    function (e) {

      var d = drawer();

      if (!d || d.hidden) {
        return;
      }


      if (e.key === 'Escape') {

        closeCart();
        return;

      }


      if (e.key !== 'Tab') {
        return;
      }


      var f =
        d.querySelectorAll(
          'button:not([disabled]), a[href], input, [tabindex="0"], iframe'
        );


      if (!f.length) {
        return;
      }


      var first = f[0];
      var last = f[f.length - 1];


      if (
        e.shiftKey &&
        document.activeElement === first
      ) {

        e.preventDefault();
        last.focus();

      } else if (
        !e.shiftKey &&
        document.activeElement === last
      ) {

        e.preventDefault();
        first.focus();

      }

    }
  );


  /* ---------- Init ---------- */

  function init() {

    document.querySelectorAll(
      '[data-gz-pack-form]'
    ).forEach(updatePacks);


    /*
     * Fenêtre de choix :
     * à la fermeture, le focus revient
     * sur la tuile qui l'a ouverte.
     */
    document.querySelectorAll(
      '[data-gz-sheet]'
    ).forEach(function (sheet) {

      sheet.addEventListener(
        'close',
        function () {

          if (
            sheet.gzTrigger &&
            sheet.gzTrigger.focus
          ) {

            sheet.gzTrigger.focus();

          }

        }
      );

    });


    /*
     * La barre collante se cache quand
     * un bouton d'achat plus complet
     * est visible.
     */
    var sticky =
      document.querySelector(
        '[data-gz-sticky]'
      );

    var watched =
      document.querySelectorAll(
        '[data-gz-packs], [data-gz-hide-sticky]'
      );


    if (
      sticky &&
      watched.length &&
      'IntersectionObserver' in window
    ) {

      var visible = new Set();


      var io =
        new IntersectionObserver(
          function (entries) {

            entries.forEach(
              function (en) {

                if (
                  en.isIntersecting
                ) {

                  visible.add(
                    en.target
                  );

                } else {

                  visible.delete(
                    en.target
                  );

                }

              }
            );


            sticky.hidden =
              visible.size > 0;

          },
          {
            threshold: 0.05
          }
        );


      watched.forEach(
        function (el) {
          io.observe(el);
        }
      );

    }


    document.querySelectorAll(
      '[data-gz-gallery]'
    ).forEach(function (g) {

      var track =
        g.querySelector(
          '[data-gz-track]'
        );


      /*
       * Chargement à la demande :
       * on charge la photo voisine,
       * pas toute la galerie.
       */
      var deferred =
        g.querySelectorAll(
          'img[data-src]'
        );


      if (
        'IntersectionObserver' in window
      ) {

        var lazyIo =
          new IntersectionObserver(
            function (entries) {

              entries.forEach(
                function (en) {

                  if (
                    en.isIntersecting
                  ) {

                    loadDeferred(
                      en.target.parentNode
                    );

                    lazyIo.unobserve(
                      en.target
                    );

                  }

                }
              );

            },
            {
              root: track,
              rootMargin:
                '0px 100% 0px 100%'
            }
          );


        deferred.forEach(
          function (img) {
            lazyIo.observe(img);
          }
        );

      } else {

        loadDeferred(g);

      }


      /*
       * Dès la première interaction,
       * on charge le reste pour éviter
       * tout blanc pendant le balayage.
       */
      [
        'pointerdown',
        'touchstart',
        'focusin'
      ].forEach(function (evt) {

        track.addEventListener(
          evt,
          function () {
            loadDeferred(g);
          },
          {
            once: true,
            passive: true
          }
        );

      });


      g.querySelectorAll(
        '.gz-gallery__thumbs'
      ).forEach(function (t) {

        t.addEventListener(
          'pointerdown',
          function () {
            loadDeferred(g);
          },
          {
            once: true,
            passive: true
          }
        );

      });


      var timer;


      track.addEventListener(
        'scroll',
        function () {

          loadDeferred(g);

          clearTimeout(timer);

          timer =
            setTimeout(
              function () {
                galleryMarkActive(g);
              },
              80
            );

        },
        {
          passive: true
        }
      );


      var checked =
        document.querySelector(
          'input[name="id"]:checked'
        );


      if (
        checked &&
        checked.dataset.media
      ) {

        galleryScrollTo(
          g,
          checked.dataset.media,
          true
        );

      }


      galleryMarkActive(g);

    });
  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }

})();